import { render, staticRenderFns } from "./beneficiary-philgov-detail-card.vue?vue&type=template&id=df4bff98&"
import script from "./beneficiary-philgov-detail-card.vue?vue&type=script&lang=js&"
export * from "./beneficiary-philgov-detail-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports